import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';
import { ReactNode } from 'react';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ 
  icon: Icon, 
  title, 
  description, 
  action,
  className 
}: EmptyStateProps) {
  return (
    <div className={cn(
      'flex flex-col items-center justify-center py-16 px-4 text-center',
      className
    )}>
      <div className="w-16 h-16 rounded-full bg-grey-100 flex items-center justify-center mb-4">
        <Icon className="w-8 h-8 text-grey-400" />
      </div>
      <h3 className="text-heading-3 text-secondary mb-2">{title}</h3>
      <p className="text-body-sm text-grey-500 max-w-sm mb-6">{description}</p>
      {action}
    </div>
  );
}


